export class OrganizationSearchResult {
    constructor(data) {
        this.organizationId = data.organizationId;
        this.hccisId = data.hccisId;
        this.organizationName = data.organizationName;
        this.organizationTypeDesc = data.organizationTypeDesc;
        this.organizationInformation = data.organizationInformation;
    }
}